<div class="admin-container">

  <app-loading *ngIf="loading"></app-loading>

  <div class="admin-container-header">
    <h4 class="admin-container-header-item">
      {{ getTitle() }} — {{ isNew ? 'New item' : (getElementLabel() || 'Edit') }}
    </h4>
    <div class="admin-container-header-buttons">
      <h4
        *ngIf="canDelete()"
        (click)="deleteItem()"
        class="admin-container-header-buttons-save admin-container-header-buttons-delete"
      >
        Delete
      </h4>
      <h4
        (click)="onSubmit()"
        class="admin-container-header-buttons-save"
        [class.admin-container-header-buttons-save-inactive]="myForm.invalid || loadingForSaving"
      >
        {{ loadingForSaving ? 'Saving...' : 'Save' }}
      </h4>
      <h4 (click)="openPage()" class="admin-container-header-buttons-save">
        Open the page
      </h4>
      <h4 (click)="back()" class="admin-container-header-logout">
        Back
        <app-icon style="margin-left: 0.4rem;" [icon]="Icons.arrowRight" [invert]="true"/>
      </h4>
    </div>
  </div>

  <div class="admin-container-content">
    <div class="admin-container-content-details">
      <form [formGroup]="myForm" (ngSubmit)="onSubmit()">

        <div class="field" *ngIf="myForm.get('id')">
          <div class="field-text">
            <label for="id">ID</label>
            <input id="id" name="id" formControlName="id" type="text"/>
          </div>
        </div>

        <ng-container *ngIf="elementType === 'airports'">
          <div class="field field-half-width">
            <div class="field-text">
              <label for="name">Airport Name *</label>
              <input id="name" name="name" formControlName="name" type="text"/>
            </div>
          </div>

          <div class="field field-quarter-width">
            <div class="field-text">
              <label for="iata_code">IATA Code</label>
              <input id="iata_code" name="iata_code" formControlName="iata_code" type="text"/>
            </div>
          </div>

          <div class="field field-quarter-width">
            <div class="field-text">
              <label for="icao_code">ICAO Code</label>
              <input id="icao_code" name="icao_code" formControlName="icao_code" type="text"/>
            </div>
          </div>

          <div class="field field-half-width">
            <div class="field-text">
              <label for="city_code">City Code</label>
              <input id="city_code" name="city_code" formControlName="city_code" type="text"/>
            </div>
          </div>

          <div class="field field-half-width">
            <div class="field-text">
              <label for="country_code">Country Code</label>
              <input id="country_code" name="country_code" formControlName="country_code" type="text"/>
            </div>
          </div>

          <div class="field field-full-width">
            <div class="field-text">
              <label for="timezone">Timezone</label>
              <input id="timezone" name="timezone" formControlName="timezone" type="text"/>
            </div>
          </div>

          <div class="field field-full-width">
            <div class="field-text">
              <label for="website">Website</label>
              <input id="website" name="website" formControlName="website" type="text"/>
            </div>
          </div>

          <div class="field field-full-width">
            <div class="field-text">
              <label for="phone">Phone</label>
              <input id="phone" name="phone" formControlName="phone" type="text"/>
            </div>
          </div>

          <div class="field field-full-width">
            <div class="field-text">
              <label for="email">Email</label>
              <input id="email" name="email" formControlName="email" type="email"/>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="elementType === 'services'">
          <div class="field field-full-width">
            <div class="field-text">
              <label for="name">Service Name *</label>
              <input id="name" name="name" formControlName="name" type="text"/>
            </div>
          </div>

          <div class="field field-full-width">
            <div class="field-text">
              <label for="description">Description</label>
              <textarea id="description" name="description" formControlName="description" rows="4"></textarea>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="elementType === 'bookings'">

          <div class="field field-full-width">
            <h5>General</h5>
          </div>

          <div class="field field-quarter-width">
            <div class="field-text">
              <label for="status">Status *</label>
              <select id="status" formControlName="status">
                <option value="DRAFT">DRAFT</option>
                <option value="CONFIRMED">CONFIRMED</option>
                <option value="CANCELLED">CANCELLED</option>
              </select>
            </div>
          </div>

          <div class="field field-quarter-width">
            <div class="field-text">
              <label for="tripType">Trip Type</label>
              <select id="tripType" formControlName="tripType">
                <option value="one_way">One way</option>
                <option value="round_trip">Round trip</option>
              </select>
            </div>
          </div>

          <div class="field field-quarter-width">
            <div class="field-text">
              <label for="subtotal">Subtotal</label>
              <input id="subtotal" formControlName="subtotal" type="number"/>
            </div>
          </div>

          <div class="field field-quarter-width">
            <div class="field-text">
              <label for="total">Total</label>
              <input id="total" formControlName="total" type="number"/>
            </div>
          </div>

          <div class="field field-full-width">
            <h5>Flight Information</h5>
          </div>

          <div class="field field-half-width">
            <div class="field-text">
              <label for="flightNumber">Flight Number *</label>
              <input id="flightNumber" formControlName="flight.flightNumber" type="text"/>
            </div>
          </div>

          <div class="field field-half-width">
            <div class="field-text">
              <label for="date">Date *</label>
              <input id="date" formControlName="flight.date" type="date"/>
            </div>
          </div>

          <div class="field field-half-width">
            <div class="field-text">
              <label for="time">Time</label>
              <input id="time" formControlName="flight.time" type="time"/>
            </div>
          </div>

          <div class="field field-half-width">
            <div class="field-text">
              <label for="terminal">Terminal</label>
              <input id="terminal" formControlName="flight.terminal" type="text"/>
            </div>
          </div>

          <div class="field field-half-width">
            <div class="field-text">
              <label for="departure">Departure</label>
              <input id="departure" formControlName="flight.departure" type="text"/>
            </div>
          </div>

          <div class="field field-half-width">
            <div class="field-text">
              <label for="arrival">Arrival</label>
              <input id="arrival" formControlName="flight.arrival" type="text"/>
            </div>
          </div>

          <div class="field field-quarter-width">
            <div class="field-text">
              <label for="duration">Duration</label>
              <input id="duration" formControlName="flight.duration" type="text" placeholder="10h 30m"/>
            </div>
          </div>

          <div class="field field-quarter-width">
            <div class="field-text">
              <label for="direction">Direction</label>
              <input id="direction" formControlName="flight.direction" type="text" placeholder="Departure"/>
            </div>
          </div>

          <div class="field field-half-width">
            <div class="field-text">
              <label for="flightType">Flight Type</label>
              <input id="flightType" formControlName="flight.flightType" type="text" placeholder="International"/>
            </div>
          </div>

          <div class="field field-full-width">
            <h5>Contact Information</h5>
          </div>

          <div class="field field-half-width">
            <div class="field-text">
              <label for="phone">Phone</label>
              <input id="phone" formControlName="contact.phone" type="text"/>
            </div>
          </div>

          <div class="field field-half-width">
            <div class="field-text">
              <label for="email">Email</label>
              <input id="email" formControlName="contact.email" type="email"/>
            </div>
          </div>

          <div class="field field-full-width">
            <h5>Passengers</h5>
          </div>

          <div class="field field-quarter-width">
            <div class="field-text">
              <label>Adults</label>
              <input formControlName="passengersCount.adult" type="number"/>
            </div>
          </div>

          <div class="field field-quarter-width">
            <div class="field-text">
              <label>Children</label>
              <input formControlName="passengersCount.children" type="number"/>
            </div>
          </div>

          <div class="field field-quarter-width">
            <div class="field-text">
              <label>Infants</label>
              <input formControlName="passengersCount.infant" type="number"/>
            </div>
          </div>

          <div class="field field-full-width" *ngIf="bookingPassengersDetails.length">
            <label>Passenger details</label>
            <table class="admin-readonly-table">
              <thead>
              <tr>
                <th>Name</th>
                <th>Surname</th>
                <th>Passport</th>
                <th>Date of birth</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let p of bookingPassengersDetails">
                <td>{{ p.name }}</td>
                <td>{{ p.surname }}</td>
                <td>{{ p.passportNumber }}</td>
                <td>{{ p.dateOfBirth }}</td>
              </tr>
              </tbody>
            </table>
          </div>

          <div class="field field-full-width" *ngIf="bookingAirports.length">
            <h5>Route & Services</h5>
            <table class="admin-readonly-table">
              <thead>
              <tr>
                <th>#</th>
                <th>Airport</th>
                <th>Role</th>
                <th>Leg</th>
                <th>Services</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let a of bookingAirports">
                <td>{{ a.order }}</td>
                <td>
                  <strong>{{ a.airport?.iata_code || a.airportId }}</strong>
                  <span *ngIf="a.airport?.name"> — {{ a.airport.name }}</span>
                </td>
                <td>{{ a.role }}</td>
                <td>{{ a.leg }}</td>
                <td>
                  <span *ngIf="!a.services?.length">—</span>
                  <span *ngFor="let s of a.services; let i = index">
                      {{ s.title }} ({{ s.type }}) ×{{ s.quantity }}<span *ngIf="i < a.services.length - 1">, </span>
                    </span>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </ng-container>

        <ng-container *ngIf="elementType === 'languages'">
          <div class="field field-half-width">
            <div class="field-text">
              <label for="code639_1">Code 639-1 *</label>
              <input id="code639_1" formControlName="code639_1" type="text"/>
            </div>
          </div>
          <div class="field field-half-width">
            <div class="field-text">
              <label for="code639_3">Code 639-3</label>
              <input id="code639_3" formControlName="code639_3" type="text"/>
            </div>
          </div>
          <div class="field field-half-width">
            <div class="field-text">
              <label for="englishName">English Name</label>
              <input id="englishName" formControlName="englishName" type="text"/>
            </div>
          </div>
          <div class="field field-half-width">
            <div class="field-text">
              <label for="nativeName">Native Name</label>
              <input id="nativeName" formControlName="nativeName" type="text"/>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="elementType === 'countries'">
          <div class="field field-quarter-width">
            <div class="field-text">
              <label for="code">Code *</label>
              <input id="code" formControlName="code" type="text"/>
            </div>
          </div>
          <div class="field field-quarter-width">
            <div class="field-text">
              <label for="code3">Code 3</label>
              <input id="code3" formControlName="code3" type="text"/>
            </div>
          </div>
          <div class="field field-half-width">
            <div class="field-text">
              <label for="name">Name</label>
              <input id="name" formControlName="name" type="text"/>
            </div>
          </div>
          <div class="field field-half-width">
            <div class="field-text">
              <label for="continent">Continent</label>
              <input id="continent" formControlName="continent" type="text"/>
            </div>
          </div>
          <div class="field field-half-width">
            <div class="field-text">
              <label for="population">Population</label>
              <input id="population" formControlName="population" type="number"/>
            </div>
          </div>
          <div class="field field-half-width">
            <div class="field-text">
              <label for="currency">Currency</label>
              <input id="currency" formControlName="currency" type="text"/>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="elementType === 'cities'">
          <div class="field field-half-width">
            <div class="field-text">
              <label for="slug">Slug *</label>
              <input id="slug" formControlName="slug" type="text"/>
            </div>
          </div>
          <div class="field field-half-width">
            <div class="field-text">
              <label for="city_code">City Code</label>
              <input id="city_code" formControlName="city_code" type="text"/>
            </div>
          </div>
          <div class="field field-half-width">
            <div class="field-text">
              <label for="name">Name</label>
              <input id="name" formControlName="name" type="text"/>
            </div>
          </div>
          <div class="field field-half-width">
            <div class="field-text">
              <label for="country_code">Country Code</label>
              <input id="country_code" formControlName="country_code" type="text"/>
            </div>
          </div>
          <div class="field field-half-width">
            <div class="field-text">
              <label for="timezone">Timezone</label>
              <input id="timezone" formControlName="timezone" type="text"/>
            </div>
          </div>
          <div class="field field-half-width">
            <div class="field-text">
              <label for="population">Population</label>
              <input id="population" formControlName="population" type="number"/>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="elementType === 'airport-services'">
          <div class="field field-half-width">
            <div class="field-text">
              <label for="airportId">Airport ID *</label>
              <input id="airportId" formControlName="airportId" type="number"/>
            </div>
          </div>

          <div class="field field-full-width">
            <div class="field-text">
              <label for="information">Information</label>
              <textarea id="information" formControlName="information" rows="3"></textarea>
            </div>
          </div>

          <div class="field field-full-width" *ngIf="airportServicesList.length">
            <h5>Services (read-only)</h5>
            <table class="admin-readonly-table">
              <thead>
              <tr>
                <th>Service</th>
                <th>Departure First</th>
                <th>Departure Sub.</th>
                <th>Arrival First</th>
                <th>Arrival Sub.</th>
                <th>Transit First</th>
                <th>Transit Sub.</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let s of airportServicesList">
                <td>{{ s.service?.name || s.serviceName || 'Unknown' }}</td>
                <td>{{ s.departurePriceFirst }}</td>
                <td>{{ s.departurePriceSubsequent }}</td>
                <td>{{ s.arrivalPriceFirst }}</td>
                <td>{{ s.arrivalPriceSubsequent }}</td>
                <td>{{ s.transitPriceFirst }}</td>
                <td>{{ s.transitPriceSubsequent }}</td>
              </tr>
              </tbody>
            </table>
          </div>

          <div class="field field-full-width" *ngIf="!airportServicesList.length && !isNew">
            <div class="field-events">
              <div>No services found for this airport</div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="elementType === 'main-screen-images'">
          <div class="field field-full-width">
            <div class="field-text">
              <label for="url">Image URL (S3) *</label>
              <input id="url" name="url" formControlName="url" type="url" placeholder="https://s3.../image.jpg"/>
            </div>
          </div>

          <div class="field field-full-width" *ngIf="myForm.get('url')?.value">
            <label>Preview</label>
            <div style="margin-top: 10px; border: 1px dashed #ccc; padding: 10px; border-radius: 8px; display: inline-block;">
              <img [src]="myForm.get('url')?.value" alt="Preview" style="max-width: 300px; max-height: 200px; object-fit: cover; border-radius: 4px;" onerror="this.style.display='none'">
            </div>
          </div>
        </ng-container>

      </form>
    </div>
  </div>
</div>
